export enum OperatorEnum {
  All = 0,
  Any = 1
}
